var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { EditorActions } from 'app/stores/editor/actions';
import { Prompt } from 'app/stores/editor/prompt';
import { ProjectActions } from 'app/stores/project/actions';
import { toBlob } from 'app/utils/canvas';
import { createCanvas, createElement, disposeCanvas } from 'app/utils/DOM';
import { errorNotifier } from 'app/utils/error';
import { raf, sleep } from 'app/utils/varia';
export const captureImage = createAsyncThunk('image/capture', (_, { dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    dispatch(EditorActions.showBusy({ message: 'Waiting for browser' }));
    try {
        const stream = yield ((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.getDisplayMedia({
            video: true,
            audio: false,
        }));
        if (!stream) {
            throw new Error('Media stream not found');
        }
        const video = createElement(document, 'video');
        if (!video) {
            throw new Error('Failed to create video element');
        }
        video.srcObject = stream;
        yield video.play();
        const screenCaptureDelay = configGet('screenCaptureDelay', 2000);
        yield sleep(screenCaptureDelay);
        const videoTracks = stream.getVideoTracks();
        if (!videoTracks || !videoTracks.length) {
            throw new Error('Missing video tracks');
        }
        const videoTrack = videoTracks[0];
        const settings = videoTrack.getSettings();
        const { width, height } = settings;
        video.width = width;
        video.height = height;
        const canvas = createCanvas({
            width,
            height,
            append: false,
        });
        if (!canvas) {
            throw new Error('Failed to create canvas element');
        }
        const ctx = canvas.getContext('2d');
        dispatch(EditorActions.hideBusy());
        yield raf();
        yield sleep(300);
        ctx.drawImage(video, 0, 0, video.width, video.height);
        const screenshot = yield toBlob(canvas, 'image/png');
        disposeCanvas(canvas);
        if (!screenshot) {
            throw new Error('Video frame capture failed');
        }
        videoTrack.stop();
        video.srcObject = undefined;
        const tracks = (_b = stream.getTracks) === null || _b === void 0 ? void 0 : _b.call(stream);
        if (tracks) {
            tracks.forEach((track) => track.stop());
        }
        yield dispatch(ProjectActions.createFromImageData({
            data: screenshot,
            source: 'screenshot',
        }));
    }
    catch (err) {
        errorNotifier(err, 'CaptureImage');
        yield dispatch(Prompt.show({
            title: 'Capture error',
            variant: 'error',
            content: 'Failed to capture screenshot',
        }));
    }
    dispatch(EditorActions.hideBusy());
}));
